import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "newreceiversuccess" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { "data-test": "receiver-successfully-created-heading" }, "Your receiver has been successfully created.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_button, {
      class: "mt-4 d-block m-auto",
      type: "primary",
      onClick: _ctx.createAnother,
      "data-test": "receiver-create-another-button"
    }, {
      default: _withCtx(() => [
        _createTextVNode("Create Another Receiver")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_el_button, {
      class: "mt-2 link d-block m-auto",
      type: "text",
      onClick: _ctx.toInventory,
      "data-test": "receiver-go-to-inventory-button"
    }, {
      default: _withCtx(() => [
        _createTextVNode("Go to Receiver Inventory")
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}